const initGeneralSetting = {
  generalSettings: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterCategoryPage: "",
  filterTenantPage: "",
  isFormLoading: false,
  generalSettingCategories: [],
  isFilterLoading: false,
};

export const generalSettingReducer = (
  state = initGeneralSetting,
  action: any
) => {
  if (action.type === "SET_GENERAL_SETTING") {
    return {
      ...state,
      generalSettings: action.value,
    };
  }
  if (action.type === "SET_GENERAL_SETTING_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_GENERAL_SETTING_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_GENERAL_SETTING_FILTER_PAGE") {
    return {
      ...state,
      filterCategoryPage: action.filterCategoryPage,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_SEARCH_GENERAL_SETTING") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_GENERAL_SETTING_CATEGORY") {
    return {
      ...state,
      generalSettingCategories: [{ category: "all" }, ...action.value],
    };
  }
  if (action.type === "SET_FILTER_LOADING") {
    return {
      ...state,
      isFilterLoading: action.value,
    };
  }
  return state;
};
